//------------------------------------------------------------------------------
// This file is auto-generated.
//------------------------------------------------------------------------------
// This file was generated by NTypewriter from the C# ViewModel class with the
// same class/interface name.
//
// Do not change this file.  Any changes may cause incorrect behaviour and will
// be lost if the code is regenerated.
//------------------------------------------------------------------------------

import { ItemBase } from '../internal/ItemBase';
import { ApiKeyMode } from './Enums';

export class ApiKeyDisplayItem extends ItemBase {
    ID: string | null = null;
    Name: string | null = null;
    Description: string | null = null;
    First4: string | null = null;
    Last4: string | null = null;
    Mode: ApiKeyMode = ApiKeyMode.Read;
    CreatedDate: string = "1970-01-01T00:00:00";
    LastUsedDate: string | null = null;
    Enabled: boolean = false;

    constructor(initializer?: Partial<ApiKeyDisplayItem>) {
        super();
        if (initializer) {
            Object.assign(this, initializer);
        }
    }

    static readonly ClassName: string = "ApiKeyDisplayItem";
}
